import gql from 'graphql-tag';

export default gql`
  mutation UpdateEatery(
    $id: ID!
    $data: EateryUpdateInput!
  ) {
    updateEatery(
      id: $id
      data: $data
    ) {
      id
      name
      status
      menus
      pdfs
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/UpdateEatery.ts